
    <!--
 * 竖版-页面背景
 * @LastEditTime: Wed Dec 18 2024 22:40:11 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_HKLX51"  :class="[`normal`,`u_c_HKLX51`]" ></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{},"zh-TW":{}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '页面背景';

    // 自定义setup - 开始
    ;
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_HKLX51.normal{
position:absolute;
width:10.00rem;
height:30.24rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813806663484246.jpeg);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}
}.zh-TW{
.u_c_HKLX51.normal{
position:absolute;
width:10.00rem;
height:30.24rem;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/10/169813806663484246.jpeg);
z-index:-1;
top:0;
left:50%;
transform:translateX(-50%);

}
}
</style>
